import sdk from '@trazi/billing/sdk/node';

const billingSDK = window => {
  return sdk(`${window.location.origin}/api`);
};

export default billingSDK;
